export default __webpack_public_path__ + "static/media/amazon-horizontal.ae9294c7.svg";